export default "__VITE_ASSET__Cv$QIb_9__"